import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-602daace")

_pushScopeId("data-v-602daace")
const _hoisted_1 = {
  class: "ui__reportMain_main",
  id: "boxFixedReportMain"
}
const _hoisted_2 = { class: "ui__reportMain_main_radius" }
const _hoisted_3 = { class: "ui__reportMain_promise_text" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 268V承诺")
const _hoisted_5 = {
  key: 0,
  class: "ui__reportMain_promise_color"
}
const _hoisted_6 = {
  key: 1,
  class: "ui__reportMain_promise_color"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("内错检回购 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 268V承诺")
const _hoisted_9 = {
  key: 0,
  class: "ui__reportMain_promise_color"
}
const _hoisted_10 = {
  key: 1,
  class: "ui__reportMain_promise_color"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("内错检回购，重要部件错检赔付 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 268V承诺")
const _hoisted_13 = {
  key: 0,
  class: "ui__reportMain_promise_color"
}
const _hoisted_14 = {
  key: 1,
  class: "ui__reportMain_promise_color"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("内错检赔付 ")
const _hoisted_16 = { class: "ui__reportMain_promise_text" }
const _hoisted_17 = { class: "ui__reportMain_explain" }
const _hoisted_18 = { class: "ui__reportMain_explain_left" }
const _hoisted_19 = { class: "ui__reportMain_explain_flex" }
const _hoisted_20 = {
  key: 0,
  class: "ui__reportMain_left_text"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "AI云技术检测", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "三大事故检测", -1)
const _hoisted_23 = {
  key: 1,
  class: "ui__reportMain_left_text"
}
const _hoisted_24 = {
  key: 1,
  class: "ui__reportMain_promise fs32 mt40"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "ui__reportMain_promise_text" }, " 268V买车无忧保认证合格 ", -1)
const _hoisted_26 = {
  key: 2,
  class: "ui__reportMain_explain"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "ui__reportMain_explain_left" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__reportMain_explain_flex" }, [
    /*#__PURE__*/_createVNode("div", { class: "ui__reportMain_left_text" }, [
      /*#__PURE__*/_createVNode("div", null, [
        /*#__PURE__*/_createVNode("span", null, "车况符合准入条件，付费后可享受最低一年3万公里保修")
      ])
    ])
  ])
], -1)
const _hoisted_28 = { class: "ui__reportMain_car" }
const _hoisted_29 = { class: "ui__reportMain_car_img" }
const _hoisted_30 = { class: "ui__reportMain_car_msg" }
const _hoisted_31 = { class: "ui__reportMain_car_info" }
const _hoisted_32 = { class: "ui__reportMain_car_vin" }
const _hoisted_33 = { class: "ui__comTitle_model" }
const _hoisted_34 = { class: "ui__comTitle_model_title" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 承诺保障 ")
const _hoisted_36 = {
  key: 0,
  class: "ui__comTitle_model_content"
}
const _hoisted_37 = { class: "ui__comTitle_model_head" }
const _hoisted_38 = {
  key: 1,
  class: "ui__comTitle_model_content"
}
const _hoisted_39 = { class: "ui__comTitle_model_head" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" 检测报告激活方式：")
const _hoisted_44 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" ① 微信搜索“268V车况检测专家”小程序；")
const _hoisted_46 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" ② 点击【激活保障】，进入激活页面；")
const _hoisted_48 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" ③ 填写成交信息及上传交易凭证，即可激活90天回购保障。")
const _hoisted_50 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" 说明：请在车辆完成交易及过户后再激活保障。 ")
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" 通过268V买车无忧检认证的车辆，检测保障激活后，")
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { key: 2 }
const _hoisted_56 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode("您车辆的发动机、变速箱出现拆卸未换、漏油、 渗油、修复痕迹，检测报告未准确反映的，268V负责进行错检赔付。")
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "prop_up_height" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("span", null, "检测报告激活方式：", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("span", null, "① 微信搜索“268V车况检测专家”小程序；", -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("span", null, "② 点击【激活保障】，进入激活页面；", -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createTextVNode("③ 填写成交信息及上传交易凭证，即可激活")
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = /*#__PURE__*/_createTextVNode("天")
const _hoisted_69 = /*#__PURE__*/_createTextVNode("赔付")
const _hoisted_70 = /*#__PURE__*/_createTextVNode("回购")
const _hoisted_71 = /*#__PURE__*/_createTextVNode("保障。")
const _hoisted_72 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("span", null, "说明：请在车辆完成交易及过户后再激活保障。", -1)
const _hoisted_74 = {
  key: 0,
  class: "ui__comTitle_model_head pt0 mt40"
}
const _hoisted_75 = {
  key: 1,
  class: "ui__comTitle_model_cnt"
}
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 双认证表示车辆通过了268V车况检测认证及质保检测合格认证，车况符合准入条件并享有购买“最低一年3万公里”质保产品的资格（精选保障plus产品可享一年不限公里保修），如未购买该产品则不享有相应的保修服务保障，具体保修范围、最高赔付限额、保修期限（年限及公里数限制）等以实际购买产品为准。 ")
const _hoisted_77 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" 购买流程：")
const _hoisted_80 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_81 = /*#__PURE__*/_createTextVNode("① 经过双认证或质保检测合格")
const _hoisted_82 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_83 = /*#__PURE__*/_createTextVNode("② 选择对应产品付费购买")
const _hoisted_84 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_85 = /*#__PURE__*/_createTextVNode("③ 提供所需材料")
const _hoisted_86 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_87 = /*#__PURE__*/_createTextVNode("④ 保修服务生效 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.state.point === 'N' && _ctx.state.reportLevel !== 16)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["ui__reportMain_promise", {"fs32": _ctx.state.reportLevel === 32}]
          }, [
            (_ctx.state.channelType !== 'lingshou')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode("span", _hoisted_3, [
                    (_ctx.state.reportLevel === 0 || _ctx.state.reportLevel === 1)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_4,
                          (_ctx.state.channelType === 'jiaxuan')
                            ? (_openBlock(), _createBlock("span", _hoisted_5, "100天"))
                            : (_openBlock(), _createBlock("span", _hoisted_6, "90天")),
                          _hoisted_7
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.state.reportLevel === 2)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _hoisted_8,
                          (_ctx.state.channelType === 'jiaxuan')
                            ? (_openBlock(), _createBlock("span", _hoisted_9, "100天"))
                            : (_openBlock(), _createBlock("span", _hoisted_10, "90天")),
                          _hoisted_11
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.state.reportLevel === 8 || _ctx.state.reportLevel === 32)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                          _hoisted_12,
                          (_ctx.state.channelType === 'jiaxuan')
                            ? (_openBlock(), _createBlock("span", _hoisted_13, "100天"))
                            : (_openBlock(), _createBlock("span", _hoisted_14, "90天")),
                          _hoisted_15
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.state.point === 'N' && _ctx.state.reportLevel !== 16)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        class: "ui__reportMain_explain_right",
                        src: require('@/assets/image/iconRight.png'),
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showModel && _ctx.showModel(...args)))
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode("span", _hoisted_16, _toDisplayString(_ctx.state.commitmentTitle), 1),
                  (_ctx.state.point === 'N' && _ctx.state.commitmentTitle !== '')
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        class: "ui__reportMain_explain_right",
                        src: require('@/assets/image/iconRight.png'),
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showModel && _ctx.showModel(...args)))
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true)
                ], 64))
          ], 2))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            (_ctx.state.channelType !== 'lingshou')
              ? (_openBlock(), _createBlock("div", _hoisted_20, [
                  _createVNode("div", null, [
                    _createVNode("img", {
                      src: require('@/assets/image/iconRightGrey.png')
                    }, null, 8, ["src"]),
                    _hoisted_21
                  ]),
                  _createVNode("div", null, [
                    _createVNode("img", {
                      src: require('@/assets/image/iconRightGrey.png')
                    }, null, 8, ["src"]),
                    _createVNode("span", null, _toDisplayString(_ctx.state.specialNum) + "项专项检测", 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("img", {
                      src: require('@/assets/image/iconRightGrey.png')
                    }, null, 8, ["src"]),
                    _hoisted_22
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_23, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.detectionLabel, (item, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _createVNode("img", {
                        src: require('@/assets/image/iconRightGrey.png')
                      }, null, 8, ["src"]),
                      _createVNode("span", null, _toDisplayString(item), 1)
                    ]))
                  }), 128))
                ]))
          ])
        ])
      ]),
      (_ctx.state.point === 'N' && _ctx.state.reportLevel === 32)
        ? (_openBlock(), _createBlock("div", _hoisted_24, [
            _hoisted_25
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.reportLevel === 32)
        ? (_openBlock(), _createBlock("div", _hoisted_26, [
            _hoisted_27
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_28, [
        _createVNode("div", _hoisted_29, [
          _createVNode("img", {
            src: _ctx.state.carImg,
            style: {"pointer-events":"none"}
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_30, [
          _createVNode("div", _hoisted_31, _toDisplayString(_ctx.state.carModel), 1),
          _createVNode("div", _hoisted_32, "VIN：" + _toDisplayString(_ctx.state.vin), 1)
        ])
      ])
    ]),
    _withDirectives(_createVNode("div", {
      class: "ui__comTitle_model_cover",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hiddenModel && _ctx.hiddenModel(...args)))
    }, null, 512), [
      [_vShow, _ctx.state.isShowModel]
    ]),
    _withDirectives(_createVNode("div", _hoisted_33, [
      _createVNode("div", _hoisted_34, [
        _hoisted_35,
        _createVNode("img", {
          src: require('../../../assets/image/close.png'),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hiddenModel && _ctx.hiddenModel(...args)))
        }, null, 8, ["src"])
      ]),
      (_ctx.state.channelType === 'lingshou')
        ? (_openBlock(), _createBlock("div", _hoisted_36, [
            _createVNode("div", _hoisted_37, _toDisplayString(_ctx.state.commitmentTitle), 1),
            _createVNode("div", {
              class: ["ui__comTitle_model_cnt", {"pb0": _ctx.state.reportLevel === 32}]
            }, _toDisplayString(_ctx.state.statementCommitment), 3)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_38, [
            _createVNode("div", _hoisted_39, [
              (_ctx.state.reportLevel === 0 || _ctx.state.reportLevel === 1)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" 268V承诺" + _toDisplayString(_ctx.state.protectTime) + "天内错检回购 ", 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.state.reportLevel === 2)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" 268V承诺" + _toDisplayString(_ctx.state.protectTime) + "天内错检回购，重要部件错检赔付 ", 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.state.reportLevel === 8 || _ctx.state.reportLevel === 32)
                ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" 268V承诺" + _toDisplayString(_ctx.state.protectTime) + "天内错检赔付 ", 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", {
              class: ["ui__comTitle_model_cnt", {"pb0": _ctx.state.reportLevel === 32}]
            }, [
              (_ctx.state.reportLevel === 32)
                ? (_openBlock(), _createBlock("div", _hoisted_40, [
                    _createTextVNode(" 通过268V买车无忧检认证的车辆，检测保障激活后，自承保激活日起" + _toDisplayString(_ctx.state.protectTime) + "天内，若您发现被检测车辆为重大事故、火烧、泡水车而检测报告未准确反映的，268V负责对该车辆进行差价赔付或按交易价回购。 ", 1),
                    _hoisted_41,
                    _hoisted_42,
                    _hoisted_43,
                    _hoisted_44,
                    _hoisted_45,
                    _hoisted_46,
                    _hoisted_47,
                    _hoisted_48,
                    _hoisted_49,
                    _hoisted_50,
                    _hoisted_51
                  ]))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode("div", null, [
                      _hoisted_52,
                      (_ctx.state.reportLevel === 8)
                        ? (_openBlock(), _createBlock("span", _hoisted_53, "自过户完成之日起" + _toDisplayString(_ctx.state.protectTime) + "天内", 1))
                        : (_openBlock(), _createBlock("span", _hoisted_54, "自承保激活日起" + _toDisplayString(_ctx.state.protectTime) + "天内", 1)),
                      _createTextVNode("，若您发现被检测车辆为重大事故、火烧、泡水车而检测报告未准确反映的，268V负责对该车辆进行差价赔付" + _toDisplayString(_ctx.state.reportLevel === 8 ? '。': '或按交易价回购。') + " ", 1),
                      (_ctx.state.reportLevel === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_55, [
                            _hoisted_56,
                            _hoisted_57
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_58,
                    _createVNode("div", null, [
                      _hoisted_59,
                      _hoisted_60,
                      _hoisted_61,
                      _hoisted_62,
                      _hoisted_63,
                      _hoisted_64,
                      _createVNode("span", null, [
                        _hoisted_65,
                        (_ctx.state.channelType === 'jiaxuan')
                          ? (_openBlock(), _createBlock("span", _hoisted_66, "100"))
                          : (_openBlock(), _createBlock("span", _hoisted_67, "90")),
                        _hoisted_68,
                        (_ctx.state.reportLevel === 8)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                              _hoisted_69
                            ], 64))
                          : (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                              _hoisted_70
                            ], 64)),
                        _hoisted_71
                      ]),
                      _hoisted_72,
                      _hoisted_73
                    ])
                  ], 64))
            ], 2),
            (_ctx.state.reportLevel === 32)
              ? (_openBlock(), _createBlock("div", _hoisted_74, " 268V买车无忧保认证合格 "))
              : _createCommentVNode("", true),
            (_ctx.state.reportLevel === 32)
              ? (_openBlock(), _createBlock("div", _hoisted_75, [
                  _hoisted_76,
                  _hoisted_77,
                  _hoisted_78,
                  _hoisted_79,
                  _hoisted_80,
                  _hoisted_81,
                  _hoisted_82,
                  _hoisted_83,
                  _hoisted_84,
                  _hoisted_85,
                  _hoisted_86,
                  _hoisted_87
                ]))
              : _createCommentVNode("", true)
          ]))
    ], 512), [
      [_vShow, _ctx.state.isShowModel]
    ])
  ], 512)), [
    [_vShow, _ctx.state.reportLevel !== 4]
  ])
})